module.exports = __webpack_public_path__ + "img/hamburger.4247e361.svg";